import React, { useCallback, useContext } from 'react'
import { matchUpdateTypes } from '../cnr/reducers/SportsSeasonReducer';
import { useAppUserAccess } from 'global/cnr/contexts/useHelpers/useAppUserAccess';
import { ParentContext } from 'global/cnr/contexts/ParentContext';
import { SportsSeasonContext } from '../cnr/contexts/SportsSeasonContext';
// import { updateTheMatch } from '../dbActions/updateMatch';
import { _matchResultTypes } from '../cnr/reducers/SportsMatchReducer';
import { updateParentKeyData_sports } from '../cnr/reducers/reducerHelpers/parentKeySportsData';
import { openExternal } from 'global/viewSettings/helpers/settingsLinks';
import { seasonalDataHelpers, seasonalUpdateTypes } from '../cnr/reducers/reducerHelpers/seasonalDataHelpers';
import { seasonalHelpers } from '../cnr/reducers/reducerHelpers/seasonalHelpers';
import { realtimeDocumentTypes } from '../cnr/reducers/SportsEditMatchReducer';
import { createRefPath_event } from 'global/firestoreData/appData/appRefPaths'
import { writeBatch } from 'firebase/firestore';
import { _cacheGroupTypes } from 'global/cnr/contexts/useHelpers/useTimestamp';
import { logBatch } from 'global/cnr/reducers/reducerHelpers/logging';
import { ref, set } from 'firebase/database';

const _allowMatchEdit = true;

export const useMatchUpdate = () => {

  const appUserAccess = useAppUserAccess()
  const { uid, displayName } = appUserAccess ?? {}

  const parentContext = useContext(ParentContext);
  const { states, fns, fn_cls } = parentContext ?? {}
  const { app_state, paps_state } = states
  const { mainDb, app_ts } = app_state
  const { pathViews } = paps_state
  const { database_fns } = fns

  // sportsSeasonContext
  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state } = sportsSeasonContext ?? {}
  const { currentSeason_info, sportPermissions, sportDataSettings } = sportsSeason_state ?? {}
  const { latestSeason, sportsKey } = currentSeason_info ?? {}

  const { getSports_collectionItem } = seasonalDataHelpers(mainDb, database_fns, pathViews)

  const handle_rtScore = useCallback(async ({ match_edit, callback }) => {
    const { results, id: matchId } = match_edit ?? {}
    const submissionRef = ref(app_ts.realtime, `matchResults/${pathViews.sports}/${matchId}/${uid}`);

    const submissionData = {
      results: results,
      displayName: displayName,
      createdAt: Date.now(),
      status: 'pending'
    };

    try {
      set(submissionRef, submissionData);
      callback()
      console.log('Submission updated successfully:', submissionData);
    } catch (error) {
      callback()
      console.error('Error updating submission:', error);
    }
  }, [])


  const handle_updateMatchScore = useCallback(async ({ match_edit, match_rt, _results, sortedAthletes, playoffMatches, matchResultType, useRtMatchData, updateRtGameDayData, callback }) => {
    const updateProps = {
      match_edit,
      match_rt,
      sortedAthletes,
      _results: _results || match_edit?._results,
      playoffMatches
    }

    const sportCollectionName = '_matches_seasonal'

    const pks = seasonalHelpers.getPks(pathViews, latestSeason, sportsKey, ['teams'])
    const _sportsYearCollectionItem = await getSports_collectionItem(pks, sportCollectionName, true)

    if (_sportsYearCollectionItem && !_.isEmpty(_sportsYearCollectionItem)) {
      const { _itemKey: _docKey } = _sportsYearCollectionItem
      const { _matchCollectionKey, _itemKey, results } = match_edit ?? {}
      const refPath = createRefPath_event(pathViews, [sportCollectionName, _docKey, 'matches', _matchCollectionKey])

      const fieldPath = `matches.${_itemKey}`

      const updates = {
        [`${fieldPath}.results`]: results,
        // [`${fieldPath}.startTime`]: 'Some Start Time'
      }

      await safeUpdateNested({
        mainDb,
        pathViews,
        refPath,
        fieldPath: fieldPath,
        updates: updates,
        database_fns,
        onSuccess: callback,
        onError: (err) => console.error('Error updating match results:', err)
      })
    }
    // await update_seasonalOrGlobal(seasonalUpdateTypes.matches, _updateProps)
    // console.log('_updateProps', _updateProps)
  }, []);

  const handle_updateMatch = useCallback(({ matchPendingUpdate, match_true, match_edit, callback }) => {
    updateMatch(fn_cls, matchPendingUpdate, match_true, match_edit)
  }, []);

  return { handle_updateMatch, handle_updateMatchScore, handle_rtScore }
}

const updateMatch = (fn_cls, matchPendingUpdate, match_true, match_edit) => {

  matchPendingUpdate.match_true = match_true
  matchPendingUpdate.match_edit = match_edit

  const { matchUpdateType } = matchPendingUpdate
  const actionProps = matchPendingUpdate

  switch (matchUpdateType) {

    case matchUpdateTypes.notifyMatch:
      // const sendProps = appUserAccess ? { profileId: appUserAccess.profileId, fcmTokens: appUserAccess.fcmTokens } : {}
      // const topicData = getNotificationData(notificationTypes.notification, pathViews, { topic: viewKey }, { title: 'Match Results', body: scoreDisplay_full, clickPath: pathName })
      // fsfn_sendNotification(sendProps, topicData, pathViews)
      break;

    case matchUpdateTypes.addToHistory:
      const { startDate, levels } = match_edit
      const results = match_edit ? match_edit._results : undefined;
      const { winner, loser } = results ?? {}
      if (winner && loser) {
        const d = new Date(startDate)
        const year = d.getFullYear()
        const data = {
          [levels]: {
            [year]: {
              winner: winner.name,
              runnerUp: loser.name
            }
          }
        }
        updateParentKeyData_sports(database_fns, sportPermissions, '_history', pathViews, 'history', data, null, sportsKey)
      }
      break;

    case matchUpdateTypes.addConsolationMatch:
      console.log('actionProps', actionProps)
      break;

    case matchUpdateTypes.openDatabase:
      const { _matchCollectionKey, isPlayoff } = match_true ?? {}
      const dbCollection = isPlayoff ? 'playoffMatches' : 'matches'
      openExternal.firebaseDb(pathViews, _sportCollections._matches_seasonal, pk_matches_seasonal, false, false, false, [dbCollection, _matchCollectionKey])
      break;

    case matchUpdateTypes.updateGsScore:
      fn_cls.updateGoogleSheetRow(match_edit)
      break;

    case matchUpdateTypes.deleteMatch:
    case matchUpdateTypes.updateMatchDayMatch:
    case matchUpdateTypes.cancelMatch:
    case matchUpdateTypes.confirmMatchDate:
    case matchUpdateTypes.deleteRealtimeMatch:
    case matchUpdateTypes.removeResults:
    case matchUpdateTypes.postponeMatch:
    case matchUpdateTypes.resetByeMatch:
    case matchUpdateTypes.updateMatchDetails:
    case matchUpdateTypes.updateScore:
      let _matchResultType = _matchResultTypes.normal;
      switch (matchUpdateType) {
        case matchUpdateTypes.updateMatchDayMatch:
          _matchResultType = _matchResultTypes.matchDay
          break;
        default:
        // nothing
      }
      actionProps.realtimeMatch = _realtimeMatch
      const matchPropsOther = {
        actionProps: actionProps,
        appUserInfo,
        callback: action.callback,
        database_fns,
        latestSeason,
        matchResultType: _matchResultType,
        matchUpdateType: matchUpdateType,
        pathViews,
        sportDataSettings,
        sportPermissions,
        sportsKey,
        useRtMatchData,
      }
      ammendMatchProps(update_seasonalOrGlobal, mainRt, matchPropsOther)
      break;

    case matchUpdateTypes.updatePendingMatch:
      break;

    case matchUpdateTypes.updatePrePendingMatch:
      break;

    default:
      break;
  }
}

const ammendMatchProps = (getUpdateProps, matchProps) => {

  const {
    actionProps,
    appUserInfo,
    callback,
    currentUserId,
    database_fns,
    latestSeason,
    matchResultType,
    matchUpdateType,
    pathViews,
    sportDataSettings,
    sportPermissions,
    sportsKey,
    updateRtGameDayData,
  } = matchProps

  const { match_edit, match_rt, sortedAthletes, matches_playoffs } = actionProps ?? {}
  const { useRtGameDayData } = sportDataSettings

  let _useRtGameDayData

  let _match_current;

  switch (matchResultType) {
    case _matchResultTypes.realtime:
      _match_current = match_rt
      break;
    case _matchResultTypes.matchDay:
      _match_current = match_edit
      break;
    case _matchResultTypes.normal:
      _match_current = match_edit
      break;
    default:
    // nothing
  }

  const { _itemKey: _matchKey, _results, isPlayoff, startDate, startTime, location, home, away, _matchCollectionKey } = _match_current ?? {}
  const { score, scores, winner, loser } = _results ?? {}

  let _collectionName = isPlayoff ? 'playoffMatches' : 'matches'
  let _dataType = isPlayoff ? 'playoffMatches' : 'matches'
  let _collectionName_scores = isPlayoff ? 'playoffScores' : 'scores'
  let _dataType_scores = isPlayoff ? 'playoffScores' : 'scores'

  let _updateScoreCollection;

  const pks = seasonalHelpers.getPks(pathViews, latestSeason, sportsKey, ['teams'])

  const matchData = {}
  const matchData_scores = {}

  if (_match_current && _matchKey) {

    const _mk = _dataType + '.' + _matchKey
    const _mk_scores = _dataType_scores + '.' + _matchKey

    if (!_match_current.teams && home.id && away.id) {
      matchData[_mk + '.teams'] = [home.id, away.id];
    }

    // depending of the matchUpdateType, modify the corresponding prop...

    switch (matchUpdateType) {
      case matchUpdateTypes.deleteRealtimeMatch:
        // do nothing here
        break;

      case matchUpdateTypes.deleteMatch:
        matchData[_mk] = deleteField();
        break;

      case matchUpdateTypes.removeResults:
        matchData[_mk + '.results'] = deleteField();
        break;

      case matchUpdateTypes.postponeMatch:
        matchData[_mk + '.postponed'] = true;
        matchData[_mk + '.cancelled'] = deleteField();
        break;

      case matchUpdateTypes.cancelMatch:
        matchData[_mk + '.cancelled'] = true;
        matchData[_mk + '.postponed'] = deleteField();
        break;

      case matchUpdateTypes.resetByeMatch:
        const { place, poolName, matchNumber } = _match_current.pending ?? {}
        const byeName = poolName + ' #' + matchNumber + '/' + place
        console.log('byeName', byeName)
        matchData[_mk + '.away'] = { id: _match_current.seeds.away, name: byeName };
        break;

      case matchUpdateTypes.updateMatchDetails:
        if (location) {
          matchData[_mk + '.location'] = location
        };
        matchData[_mk + '.startDate'] = startDate;
        matchData[_mk + '.startTime'] = startTime;
        matchData[_mk + '.postponed'] = deleteField();
        matchData[_mk + '.cancelled'] = deleteField();
        break;

      case matchUpdateTypes.updateMatchDayMatch:
        if (score || scores) {
          const res = {}

          if (scores) {
            if (_.isArray(scores)) {
              res.scores = _.compact(scores);
            } else {
              res.scores = scores;
            }
          }
          if (score) { res.score = score; }
          matchData[_mk + '.results'] = res;
          matchData_scores[_mk_scores] = { ...res };
        }
        break;

      case matchUpdateTypes.updateScore:

        _useRtGameDayData = useRtGameDayData && updateRtGameDayData

        if (score || scores) {

          const res = {}

          if (scores) {
            if (_.isArray(scores)) {
              res.scores = _.compact(scores);
            } else {
              res.scores = scores;
            }
          }
          if (score) { res.score = score; }

          let players;

          if (sortedAthletes) {
            players = {}
            sortedAthletes.forEach((sa, index) => {
              players[sa.key] = {
                firstName: sa.firstName,
                lastName: sa.lastName,
                position: index
              }
            })
            res.players = players
          }

          matchData[_mk + '.results'] = res;
          matchData_scores[_mk_scores] = { ...res };
          _updateScoreCollection = true
        }
        break;

      default:
        return;
    }

    // if useRtGameDayData (in settings) is true, only the realtime (matchDay) database will be updated

    const matchData_rt = {}
    if (scores) { matchData_rt.scores = scores; }
    if (score) { matchData_rt.score = score; }
    const rtProps = {
      appUserInfo,
      currentUserId,
      latestSeason,
      match_key: _matchKey,
      pathViews,
      realtimeDocumentType: realtimeDocumentTypes.matchDay,
      results: matchData_rt,
      seasonalUpdateType: seasonalUpdateTypes.matches,
      sportDataSettings,
      sportPermissions,
      callback,
    }

    const opts = { subDocumentKey: _matchCollectionKey, appUserInfo, rtProps }

    if (_useRtGameDayData) {
      return rtProps
      // realTimeScoring.updateRealtimeScoresToDatabase(mainRt, rtProps)
    } else {
      switch (matchUpdateType) {
        case matchUpdateTypes.deleteRealtimeMatch:
          // realTimeScoring.deleteRealtimeDatabaseScores(mainRt, sportPermissions, sportDataSettings, seasonalUpdateTypes.matches, pathViews, [_matchKey], appUserInfo, latestSeason)
          break;

        default:
          const _updateProps = getUpdateProps(database_fns, sportPermissions, pathViews, pks, null, _collectionName, null, matchData, opts)

          return _updateProps
        // await update_seasonalOrGlobal(seasonalUpdateTypes.matches, _updateProps)

        // if (_updateScoreCollection) {
        //   const _updateProps2 = getUpdateProps(database_fns, sportPermissions, pathViews, pks, null, _collectionName_scores, null, matchData_scores, opts)
        //   await update_seasonalOrGlobal(seasonalUpdateTypes.matches, _updateProps2)
        // }

        // if (match_rt && sportPermissions.any && sportPermissions.matches) {
        //   // await deleteRealtimeDatabaseScores(pathViews, _matchKey, appUserInfo, latestSeason)
        // }

        // if (sportPermissions.any && sportPermissions.matches && isPlayoff && matches_playoffs && matchUpdateType === matchUpdateTypes.updateScore) {
        //   updatePendingMatch(update_seasonalOrGlobal, sportPermissions, pathViews, latestSeason, sportsKey, null, _match_current, matches_playoffs, winner, loser, _collectionName, callback)
        // }
      }
    }

    return {}
    // callback(matchProps)

  }
}

export const safeUpdateNested = async ({
  mainDb,
  pathViews,
  refPath,
  fieldPath,        // e.g. 'matches.abc123.results'
  updates,
  database_fns,
  onError,
  onSuccess
}) => {
  try {
    // 1. Get the document 
    const docSnap = await database_fns.get_doc({ refPath })

    if (!docSnap) {
      console.log(`Document does not exist at path: ${refPath}`)
      return;
    }

    const docData = docSnap.data ? docSnap.data() : docSnap

    // 2. Ensure FULL path exists (not just partial)
    const exists = _.has(docData, fieldPath)

    if (!exists) {
      console.log(`Field path does not exist: ${fieldPath}`)
      return;
    }


    console.group('safeUpdateNested')
    console.log('refPath', refPath)
    console.log('updates', updates)
    console.groupEnd()
    // 4. Perform strict update

    if (_allowMatchEdit) {
      const _timestamp = Date.now()
      const batch = writeBatch(mainDb);
      database_fns.update_doc(refPath, updates, null, batch)
      database_fns.update_timestamp(_cacheGroupTypes.sportsSeasonResultsInfo, pathViews.sports, _timestamp, batch)
      logBatch(batch, updates)
      await batch.commit()
    }

    if (onSuccess) onSuccess()

  } catch (err) {
    if (onError) onError(err)
    else console.error(err)
  }
}